import Ebook from "../../common/assets/image/alpacked/ebook/ebook-banner.jpg"
import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"

const BannerWrapper = styled.div`
  height: 650px;
  overflow: hidden;
  background-image: url(${Ebook});
  background-color: #000;
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  @media only screen and (max-width: 1099px) {
    min-height: auto;
  }
  @media only screen and (max-width: 568px) {
    background-position: right;
    height: 600px;
  }

  .container {
    position: relative;
  }

  .logo {
    width: 55px;
    margin-top: 27px;
  }
`

export const BannerContent = styled.div`
  margin-top: 100px;
  width: 100%;

  @media only screen and (max-width: 991px) {
    flex-shrink: 0;
  }
  @media only screen and (max-width: 568px) {
    margin-top: 57px;
  }

  hr {
    background: ${themeGet("colors.mainBlue")};
    width: 150px;
    height: 4px;
    border: none;
    margin: 0px 0px 10px 0px;
  }

  h1 {
    font-weight: 400;
    font-size: 48px;
    color: ${themeGet("colors.white")};
    margin-bottom: 0px;
    @media only screen and (max-width: 568px) {
      font-size: 32px;
    }
  }

  .intro {
    color: ${themeGet("colors.mainBlue")};
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 14px;
  }

  .subtitle {
    color: ${themeGet("colors.white")};
    margin-bottom: 8px;
    font-weight: 400;
    font-size: 32px;
    @media only screen and (max-width: 568px) {
      font-size: 20px;
    }
  }

  .text {
    color: ${themeGet("colors.white")};
    font-size: 16px;
    line-height: 26px;
    max-width: 670px;
    @media only screen and (max-width: 568px) {
      margin-top: 24px;
    }
  }

  .reusecore__button {
    width: 229px;
    background-color: ${themeGet("colors.maiBlue")};
    color: ${themeGet("colors.white")};
    font-size: 18px;
    border-radius: 0px;
    padding: 16px 21px;
    text-transform: capitalize;
    margin-top: 25px;

    &:hover {
      background-color: ${themeGet("colors.mainBlueHover")};
    }
    @media only screen and (max-width: 568px) {
      font-size: 18px;
      width: 100%;
    }
  }
`

export default BannerWrapper
